import { NotFoundPaymentPage } from "./../../widget/payment-page";

const NotFound = () => {
  return <NotFoundPaymentPage />;
};
export default NotFound;
